__turbopack_context__.v({
  "CategoryCard": "CategoryList-module__RAhjaG__CategoryCard",
  "CategoryList": "CategoryList-module__RAhjaG__CategoryList",
  "bottom": "CategoryList-module__RAhjaG__bottom",
  "list": "CategoryList-module__RAhjaG__list",
  "title": "CategoryList-module__RAhjaG__title",
  "top": "CategoryList-module__RAhjaG__top",
});
